import { cn } from '@neo/lib/utils'
import type React from 'react'

interface AssistantBannerProps {
  visible: boolean
  className?: string
}

export const AssistantBanner = ({
  visible,
  className,
  children,
}: React.PropsWithChildren<AssistantBannerProps>) => {
  if (!visible) return null

  return (
    <div
      className={cn(
        'p-2 pb-3 rounded-t-lg -mb-2 transition-all duration-300 animate-in slide-in-from-bottom-full opacity-100 border dark:bg-muted bg-muted/50 dark:border-border border-border',
        className,
      )}
      data-testid="assistant-banner"
    >
      <div className="flex items-center gap-2">{children}</div>
    </div>
  )
}
